import React from 'react';
import { Button } from 'components/ui/button';
import { cn } from 'lib/utils';
import { STATS } from 'state/stats/type';

interface IProps {
  enabledFreq: STATS.IIntervalType[];
  activeFreq: STATS.IIntervalType;
  setActiveFreq: React.Dispatch<React.SetStateAction<STATS.IIntervalType>>;
}

const FrequencyButtonGroup = ({
  enabledFreq,
  activeFreq,
  setActiveFreq,
}: IProps) => {
  const { IIntervalType: INTERVAL } = STATS;

  const options: {
    id: string;
    label: string;
    value: STATS.IIntervalType;
  }[] = [
    { id: 'freq-daily', label: 'Daily', value: INTERVAL.DAILY },
    { id: 'freq-weekly', label: 'Weekly', value: INTERVAL.WEEKLY },
    { id: 'freq-monthly', label: 'Monthly', value: INTERVAL.MONTHLY },
  ];

  // Only show the aggregation levels valid for the selected range. A range that
  // allows a single level renders one fully-rounded button (nothing to toggle).
  const visibleOptions = options.filter(({ value }) =>
    enabledFreq.includes(value)
  );

  if (visibleOptions.length === 0) {
    return null;
  }

  return (
    <div className="flex">
      {visibleOptions.map(({ id, label, value }, index) => {
        const isFirst = index === 0;
        const isLast = index === visibleOptions.length - 1;
        const isOnly = isFirst && isLast;
        const isSelected = activeFreq === value;

        return (
          <Button
            key={id}
            id={id}
            type="button"
            data-testid={id}
            variant="secondary"
            rounded={null}
            onClick={() => setActiveFreq(value)}
            className={cn(
              'relative',
              isOnly && 'rounded',
              !isOnly && isFirst && 'rounded-l rounded-r-none',
              !isFirst && !isLast && 'rounded-none -ml-px',
              !isOnly && isLast && 'rounded-r rounded-l-none -ml-px',
              isSelected && 'z-10 bg-gray-blue-5 enabled:hover:bg-gray-blue-5'
            )}
          >
            {label}
          </Button>
        );
      })}
    </div>
  );
};

export default FrequencyButtonGroup;
